import { AUTH_URL } from "../../constants/url";
import axios from "axios";
import axiosInstance from "./axiosInstance";


export const authServices = {

  postRegisterData: async (newPost) => {
    const response = await axiosInstance.post("/users/register", newPost);
    return response.data;
  },

  postLoginData: async (newPost) => {
    const response = await axios.request({
        url: AUTH_URL + "/login",
        method: "POST",
        data: newPost
    });
    return response.data;
  },

  changePassword: async (data) => {
    const response = await axiosInstance.post("/users/change-password", data);
    return response.data;
  },

  // Forgot Password — Step 1: Request OTP
  requestOtp: async (email) => {
    const response = await axios.post(AUTH_URL + "/forgot-password", { email });
    return response.data;
  },

  // Forgot Password — Step 2: Verify OTP
  verifyOtp: async (email, otp) => {
    const response = await axios.post(AUTH_URL + "/verify-otp", { email, otp });
    return response.data;
  },

  // Forgot Password — Step 3: Reset Password
  resetPassword: async (email, newPassword, confirmPassword) => {
    const response = await axios.post(AUTH_URL + "/reset-password", { email, newPassword, confirmPassword });
    return response.data;
  },

}